import {
  InlineDatumReactComponentProps,
  useAnalytics,
} from '@stripe-internal/inline-data';
import {view, Button, Icon} from '@sail/ui';
import {external} from '@sail/icons/react/Icon';
import {FormattedMessage, defineMessages} from 'react-intl';
import {widgetLinkAction} from '@stripe-internal/conversations-ui';

const messages = defineMessages({
  problemsNotice: {
    id: 'risk.review_form.sla_message',
    description: 'SLA message',
    defaultMessage:
      'Got it. Please submit the form below to trigger a review. {slaMessage}',
  },
  reviewFormCTA: {
    id: 'risk.review_form.cta',
    description: 'Review form CTA',
    defaultMessage: 'Complete form',
  },
});

export type ValueProps = {
  sla_message?: string;
  dashboard_form_url?: string;
};

export const RiskReviewForm = (props: InlineDatumReactComponentProps) => {
  const {datum} = props;
  const value = datum.value as ValueProps;
  const analytics = useAnalytics();

  const {sla_message: slaMessage, dashboard_form_url: dashboardFormUrl} = value;

  return (
    <view.div css={{stack: 'y', gap: 'large'}}>
      <view.div css={{stack: 'y', gap: 'large'}}>
        <FormattedMessage
          {...messages.problemsNotice}
          values={{
            slaMessage,
          }}
        />
      </view.div>
      {dashboardFormUrl ? (
        <view.div css={{stack: 'y', gap: 'large'}}>
          <Button
            data-testid="review-form-cta"
            type="primary"
            css={{width: 'fill'}}
            uses={[widgetLinkAction()]}
            href={dashboardFormUrl}
            onPress={() => {
              analytics.action('uh_review_form_button', {
                dashboardFormUrl,
              });
            }}
          >
            <FormattedMessage {...messages.reviewFormCTA} />
            <Icon icon={external} />
          </Button>
        </view.div>
      ) : null}
    </view.div>
  );
};
